import React from 'react'

const AboutHeader = () => {
  return (
    <header className="about-hero text-white d-flex align-items-center"></header>
    )
}

export default AboutHeader